import {ComponentProps} from "react"
import styled, {css} from "styled-components"
import {Modal} from "react-bootstrap/lib"

import Flex from "@irati/ui/src/Flex"
import CloseBase from "@irati/ui/src/Close"

interface ModalProps {
  small?: boolean
  customWidth?: number
  mobileFullHeight?: boolean
  image?: string
}

export type StandardModalProps = ComponentProps<typeof StandardModal>

const MODAL_HEADER_DISTANCE_FROM_TOP = 60
const SMALL_MODAL_SIZE = 480

export const StandardModal = styled(Modal)<ModalProps>`
  z-index: 1040; /* Having this allows us to have two modals showing at the same time (MFAPopup and another one) */

  .modal-content {
    border-radius: ${({theme}) => theme.spacing.one};
    border-color: transparent;
    box-shadow: ${({theme}) => theme.shadows.high};
  }
  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    display: flex !important;
    .modal-dialog{
      margin: auto;
      width: 100%;
    }
  `}
  ${({small, theme}) =>
    small &&
    theme.mediaQueries.minWidthMedia.tablet`
    .modal-dialog{
      width: ${SMALL_MODAL_SIZE}px;
    }
  `}
  ${({customWidth}) =>
    customWidth && `
    @media(min-width: ${customWidth}px) {
      .modal-dialog{
        width: ${customWidth}px;
      }
    }
  `}
  ${({mobileFullHeight, image, theme}) =>
    mobileFullHeight &&
    theme.mediaQueries.maxWidthMedia.tablet`
    .modal-dialog{
      height: 100%;
    }
    .modal-content{
      display: flex;
      min-height: ${image ? `calc(100% - ${MODAL_HEADER_DISTANCE_FROM_TOP}px)` : "100%"};
    }
  `}
`

export const ImageModal = styled(StandardModal)`
  .modal-content {
    margin-top: ${MODAL_HEADER_DISTANCE_FROM_TOP}px;
  }
`

export const Buttons = styled(Flex)`
  gap: ${({theme}) => theme.spacing.two};

  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    align-items: center;
    flex-direction: column-reverse;
    justify-content: space-between;
  `}
`

export const Close = styled(CloseBase)`
  top: ${({theme}) => theme.spacing.two};
  right: ${({theme}) => theme.spacing.two};
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    top: ${theme.spacing.three};
    right: ${theme.spacing.three};
  `}
`

export const Wrapper = styled(Flex)`
  ${({theme}) => css`
    padding: ${theme.spacing.three};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.five};
    `}
  `}
`

export const PrimaryModal = styled(StandardModal)<ModalProps>`
  .modal-dialog {
    ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
      width: 75%;
    `}
  }
  .modal-content {
    overflow-y: auto;
    height: 100%;
    ${({theme}) => css`
      background-color: ${theme.colors.primary2};
    `}
  }
`
